import getUAString from "../utils/userAgent.js";
export default function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}


//////////////////
// WEBPACK FOOTER
// ../@popperjs/core/lib/dom-utils/isLayoutViewport.js
// module id = 887
// module chunks = 25